import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import AMPLITUDE_EVENT_VALUES from '../../consts/amplitude/amplitudeEventValues';
import amplitude from './amplitude';

const getResolutionMessage = (mode) => {
    switch (mode) {
        case 1:
            return AMPLITUDE_EVENT_VALUES.CONNECT_CARE_SCENARIO_M1;
        case 2:
            return AMPLITUDE_EVENT_VALUES.CONNECT_CARE_SCENARIO_M2;
        case 3:
            return AMPLITUDE_EVENT_VALUES.CONNECT_CARE_SCENARIO_M3;
        case 4:
            return AMPLITUDE_EVENT_VALUES.CONNECT_CARE_SCENARIO_M4;
        default:
            return AMPLITUDE_EVENT_VALUES.CONNECT_CARE_NO_ERRORS_FOUND;
    }
};

const trackConnectedCareDiagnosisViewed = ({isHolder, error, mode}) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.CONNECTED_CARE_DIAGNOSIS_VIEWED,
        properties: {
            ...(error ? {[AMPLITUDE_EVENT_PROPERTIES.ERROR_MESSAGE]: error} : {}),
            [AMPLITUDE_EVENT_PROPERTIES.RESOLUTION_MESSAGE]: getResolutionMessage(mode),
        },
    });
};

export default {
    trackConnectedCareDiagnosisViewed,
};
